import { render, staticRenderFns } from "./contracts-dashboard.vue?vue&type=template&id=772f7d35&"
import script from "./contracts-dashboard.vue?vue&type=script&lang=js&"
export * from "./contracts-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./contracts-dashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "contracts-dashboard.vue"
export default component.exports